import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { RootState } from "./store";
import { CombinedProfileAndJsonSchema } from "../repository/models_v2";

export const selectSearchData = (state: RootState) => state.searchData;

type SearchDataStateType = CombinedProfileAndJsonSchema | null;
const initialState = null as SearchDataStateType

export const searchDataSlice = createSlice ({
  name: "searchData",
  initialState,
  reducers: {
    updateSearchData: (
        state: SearchDataStateType,
        { payload }: PayloadAction<SearchDataStateType>
      ) => (
        state = payload
      )
  }
})

export const { updateSearchData } = searchDataSlice.actions;

export const searchDataReducer = searchDataSlice.reducer;
